var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    ref: "input",
    attrs: {
      "empty-on-focus": "",
      "input-delay": 500,
      fancy: _vm.fancy,
      label: _vm.label,
      placeholder: _vm.placeholder,
      items: _vm.foundSales,
      open: true,
      icon: _vm.icon,
    },
    on: {
      "icon-click": function ($event) {
        return _vm.trigger($event)
      },
      blur: function ($event) {
        return _vm.onBlur()
      },
      "item-click": function ($event) {
        return _vm.selectSale($event)
      },
      "fetch-more": function ($event) {
        return _vm.fetchMore()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            _c("div", [
              _vm._v(" " + _vm._s(p.item.ComputedFriendlyID) + " "),
              p.item.CompanyName
                ? _c("div", { staticClass: "smaller" }, [
                    _c("span", [_vm._v(_vm._s(p.item.CompanyName))]),
                  ])
                : _vm._e(),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }